export const JOB_STATUSES = Object.freeze({

    PENDING_METER_TOKENS:'pending-meter-tokens',

    AWAITING_CONTRACTOR_COMPANY: 'awaiting-contractor-company',
    //AWAITING_CONTRACTOR: 'awaiting-contractor',
    AWAITING_TECHNICIAN:'awaiting-technician',
  
    AWAITING_MANAGEMENT_DECISION:'awaiting-management-decision',
    AWAITING_POST_INSPECTION_COMPANY: 'awaiting-post-inspection-company',
  
    AWAITING_POST_INSPECTOR:'awaiting-post-inspector',
   
    AWAITING_QUALITY_CONTROL:'awaiting-quality-control',
    
    FAILED_EXECUTION:'failed-execution'

});

export const statuses = [
    'pending-meter-tokens',
    'pending-meter-request',
    
    'awaiting-technician',
    'awaiting-post-inspector',
    'awaiting-contractor-company',
    'awaiting-inspector-company',
    'awaiting-quality-control',
    'awaiting-management-decision',

    'assigned-post-inspector',
    'assigned-technician',

    'contractor-in-progress',
    'inspector-in-progress',


    'failed-execution',
    'approved-complete',
]

export const PROVINCES = ["Westen Cape", "Gauteng", "Northen Cape", "Mpumalanga", "North West", "Free State", "Eastern Cape", "KwaZulu-Natal", "Limpopo"];

 export const TOWNS_LIST = [
    { name: "BOKSBURG NORTH", code: "F15" },
    { name: "VAN DYK PARK", code: "G82" },
    { name: "ILLIONDALE", code: "K18" },
    { name: "SOUTHCREST", code: "A10" },
    { name: "GEORGETOWN", code: "M52" },
   ]